<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="externalAccessForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <kt-alert *ngIf="hasErrorConflict" type="warn" [showCloseButton]="false" [duration]="10000">
          <span>Oh snap! This Category is already added, try to edit the access.</span>
        </kt-alert>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Type</mat-label>
            <mat-select
              formControlName="type"
              #ts
              (selectionChange)="selectType($event.value)"
              required
            >
              <mat-option value="DOCTOR"><span>Doctor</span></mat-option>
              <mat-option value="CLIENT"><span>Client</span></mat-option>
              <mat-option value="PATIENT"><span>Patient</span></mat-option>
              <mat-option value="FACILITY"><span>Facility</span></mat-option>
              <mat-option value="AFFILIATION_GROUP"><span>Affiliation</span></mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('type', 'required')">
              Type is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Category</mat-label>
            <mat-select formControlName="relationCategory" required>
              <mat-option *ngFor="let category of relationCategoryList" [value]="category">
                {{ category.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="externalAccessForm.get('relationCategory').hasError('required')">
              Category is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Entities</mat-label>
            <mat-chip-list #chipList2 formControlName="entity">
              <mat-chip
                color="primary"
                selected
                (click)="$event.stopPropagation()"
                *ngFor="let p of selectedEntities"
                (removed)="removeEntity(p)"
              >
                {{ stringUtils.displayFullName(p) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                matInput
                (click)="$event.stopPropagation()"
                placeholder="Select Entity..."
                [matChipInputFor]="chipList2"
                #entities
                formControlName="entity"
                [matAutocomplete]="auto2"
              />
            </mat-chip-list>
            <mat-autocomplete
              #auto2="matAutocomplete"
              [displayWith]="stringUtils.displayFullName"
              (optionSelected)="selectEntities($event)"
            >
              <mat-option
                *ngFor="let entity of optionEntities"
                [value]="entity"
                [disabled]="isSelectedEntity(entity) || !entity.membersBiAccess"
                (click)="$event.stopPropagation()"
              >
                <span
                  [innerHTML]="stringUtils.displayEntityForExternalAccess(entity) | safe : 'html'"
                ></span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Page Group</mat-label>
            <mat-chip-list #chipList required formControlName="pages">
              <mat-chip
                color="primary"
                selected
                (click)="$event.stopPropagation()"
                *ngFor="let p of selectedPages"
                (removed)="remove(p)"
              >
                {{ p.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                matInput
                (click)="$event.stopPropagation()"
                placeholder="Select page..."
                [matChipInputFor]="chipList"
                #pagess
                formControlName="pages"
                required
                [matAutocomplete]="auto1"
              />
            </mat-chip-list>
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="pageFn"
              (optionSelected)="selected1($event)"
            >
              <mat-option
                *ngFor="let page of optionPages"
                [value]="page"
                [disabled]="isSelected(page)"
                (click)="$event.stopPropagation()"
              >
                <span> {{ page.name }} </span>
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('pages', 'required')">
              Page Group is
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <div class="row ml-2">
            <label>Rule:</label>
            <span style="color: red">*</span>
          </div>
          <mat-radio-group class="ml-2" [(ngModel)]="rule" [ngModelOptions]="{ standalone: true }">
            <mat-radio-button value="VIEWER">Viewer</mat-radio-button>
            <mat-radio-button value="CREATOR">Creator</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            matTooltip="Save"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
